import styled from 'styled-components';
import TextInput from '../text';
export var StyledTextInput = /*#__PURE__*/styled(TextInput).withConfig({
  displayName: "style__StyledTextInput",
  componentId: "sc-189gfm8-0"
})(["input[type='number']::-webkit-inner-spin-button,input[type='number']::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}"]);